"use client";
import { Suspense } from "react";
import { Stack } from "@mui/material";

import { useStore, observer } from "../../../service/mobx";
import FilterChips from "./FilterChips";
import Content from "./Content";

function Pane() {
  const { device, reader } = useStore();

  return device.isDesktop === false ||
    reader.config?.disable?.has("related") ? null : (
    <Stack useFlexGap spacing={3}>
      <FilterChips small chips={reader.relatedContentFiltered} />
      <Stack useFlexGap spacing={1} width="100%">
        {reader.relatedContentFiltered.map(([title, items, cardType, url]) => (
          <Suspense key={title}>
            <Content
              tab={reader.tab}
              url={url}
              title={title}
              items={items}
              cardType={cardType}
            />
          </Suspense>
        ))}
      </Stack>
    </Stack>
  );
}

export default observer(Pane);
